import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscription: localStorage.getItem('subscription')
    ? JSON.parse(localStorage.getItem('subscription'))
    : null,
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptions: (state, action) => {
      state.subscription = action.payload.subscription;
      localStorage.setItem('subscription', JSON.stringify(action.payload.subscription));
    },
  },
});

export const {setSubscriptions} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
